import { isNotEmptyAny } from '@lhb/func';

const MOCK_QUERY_KEY = 'mock';
const CHANCE_POINT_NAME = 'basicChancePointName';

/** 保存（缓存草稿）时必须校验的固定字段：机会点名称 + 详细地址（PC 与 H5 一致，后端 DE0319999101 要求）。提报才做完整必填校验。 */
export const chanceNameIdentification = CHANCE_POINT_NAME;

let nextMockChancePointId = -1;

function createMockProperty(id: number, identification: string, name: string, controlType: number, required = false) {
  // access 2：可写。模板支持审批流（supportDirectApproval 1）时，可见与可写均由 access 决定，
  // 缺少该字段会被判定为不可见，导致 mock 表单整体不展示。
  return { id, propertyId: id, identification, name, anotherName: name, controlType, required, isShow: true, access: 2, restriction: null, templateRestriction: null, templateRestrictionPassiveList: null, propertyConfigOptionVOList: null, textValue: null };
}

export function createMockLocxxTemplate(templateId?: number | null) {
  return {
    id: templateId || -1,
    dynamicRelationId: templateId || -1,
    customerTypeId: -1,
    supportDirectApproval: 1,
    propertyGroupVOList: [{
      id: -1,
      name: '点位信息',
      childList: [{
        id: -2,
        name: '基础信息',
        propertyConfigVOList: [
          createMockProperty(-101, CHANCE_POINT_NAME, '机会点名称', 3),
          createMockProperty(-102, 'area', '省市区', 14),
          createMockProperty(-103, 'basicAddress', '详细地址', 10),
          createMockProperty(-104, 'mockEvaluationNote', '评估备注', 4),
        ],
      }],
    }],
  };
}

/** Enables local Locxx form-flow mocks with ?mock=1. */
export function isLocxxOpportunityMockEnabled(search = window.location.search) {
  return new URLSearchParams(search).get(MOCK_QUERY_KEY) === '1';
}

/** Applies query-supplied field config overrides to the real template response for UI testing. */
export function applyLocxxMockTemplateConfig<T extends { propertyGroupVOList?: any[] }>(data: T, search = window.location.search): T {
  if (!isLocxxOpportunityMockEnabled(search) || !Array.isArray(data?.propertyGroupVOList)) return data;
  const params = new URLSearchParams(search);
  const hiddenFields = new Set((params.get('mockHidden') || '').split(',').filter(Boolean));
  const requiredFields = new Set((params.get('mockRequired') || '').split(',').filter(Boolean));
  const visit = (items: any[]) => {
    items.forEach((item) => {
      // 模板走审批流时可见性统一由 access 决定（1 仅可见、2 可写、3 不可见），隐藏字段需置为 3
      if (item?.identification && hiddenFields.has(item.identification)) item.access = 3;
      if (item?.identification && requiredFields.has(item.identification)) item.required = 1;
      if (Array.isArray(item?.childList)) visit(item.childList);
      if (Array.isArray(item?.propertyConfigVOList)) visit(item.propertyConfigVOList);
    });
  };
  visit(data.propertyGroupVOList);
  return data;
}

/** Returns an in-memory ID so mock submissions never call the save API. */
export function createMockChancePointId() {
  return nextMockChancePointId--;
}

export function getMissingLocxxField(
  tiledFormData: any[],
  values: Record<string, any>,
  fixedRequiredIdentifications: string[] = [],
  /** 是否来自 Locxx 拓店任务模板入口；access=null 表示模板未配置发起节点表单权限，按字段自身 required 判断 */
  taskEntry?: boolean,
  /** 传 true 时只校验 fixedRequiredIdentifications 指定的字段（保存场景只校验机会点名称），忽略模板必填。 */
  onlyFixedRequired = false,
  supportDirectApproval = 2,
) {
  const fields = (tiledFormData || []).filter((item) => onlyFixedRequired
    ? fixedRequiredIdentifications.includes(item.identification)
    : item.required === true ||
      item.required === 1 ||
      item.required === '1' ||
      fixedRequiredIdentifications.includes(item.identification));

  return fields.find((item) => {
    if (item.isShow === false) return false;
    // Locxx 下 1/3 不参与；null 在直接审批时沿用历史隐藏规则，不参与必填。
    if (taskEntry && (item.access === 1 || item.access === 3)) return false;
    if (taskEntry && supportDirectApproval === 1 && item.access !== 2) return false;
    const hasValue = Object.prototype.hasOwnProperty.call(values || {}, item.identification);
    const value = hasValue ? values[item.identification] : item.textValue;
    return !isNotEmptyAny(value) || (typeof value === 'string' && value.trim() === '');
  });
}
